import { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import {
  Box,
  Grid2 as Grid,
  Modal,
  Tooltip,
  Table,
  TableBody,
  TableRow,
  TableCell,
  List,
  ListItem,
  ListItemText,
  Button,
} from "@mui/material";
import { Cancel, CloudUpload, Edit, PictureAsPdf } from "@mui/icons-material";
import "../Artefacts.scss";
import Eye from "../../../assets/images/eye-icon.svg";
import { getType, LevelColor } from "../ServicesArtifacts";
import {
  GetArtifactByIdAsync,
  downloadArtifactPdfAsync,
  updatePdfAsync,
} from "../../../Services/Artifacts";
import { PrimaryButton, SecondaryButton } from "../../../ayudas/Themes";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import { GetDate } from "../../../ayudas/ScriptsFunctions";
import Deletemodal from "../DeleteArtifact/DeteleArtifact";
import DowloadModalArtifact from "../DownloadArtifact/DownloadArtifact";
import FileUpload from "../../../ayudas/CommonComponents/FileUpload";
import { enqueueSnackbar } from "notistack";

const styleCellName = {
  maxWidth: "150px",
  color: "#fff",
  borderColor: "transparent",
};

const styleCellDescript = {
  borderColor: "transparent",
  color: "gray",
  float: "left",
};

const styleCellLongText = {
  textAlign: "left",
  overflow: "hidden",
  wordBreak: "break-word",
  textOverflow: "ellipsis",
};
export default function DetailsmodalArtifact(props) {
  const { artefact, DataUser, Choose, Information = true } = props;
  const [open, setOpen] = useState(false);
  const [pdfFile, setpdfFile] = useState();
  const [selected, setselected] = useState();
  const [artifactData, setartifactData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [FilePdfname, setFilePdfname] = useState("No file");

  const LabelIcon = Choose ? Choose : false;
  useEffect(() => {
    if (artefact?.anexo) {
      setFilePdfname(artefact.anexo.name);
    }
  }, [artefact]);

  const handleOpen = async () => {
    const response = await GetArtifactByIdAsync(
      typeof artefact?.id === "number" ? artefact._id : artefact.id
    );
    if (response !== null) {
      setartifactData(response);
      if (response?.anexo) {
        setFilePdfname(response.anexo.name);
      }

      let dataTable = GetDataTable(response.description);
      setTableData(dataTable);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const DownloadPDFFile = async () => {
    
    let id = artefact.id.length > 10 ? artefact.id : artefact._id;

    const artifactData = {
      id: id,
      name: FilePdfname,
    };
    await downloadArtifactPdfAsync(DataUser.token, artifactData);
  };

  const handlePdfFile = (e) => {
    setselected(e.files[0]);
  };
  const canclePdfFile = () => {
    setselected();
    setpdfFile(!pdfFile);
  };
  const UpdateFile = async () => {
    const pdfData = {
      id: artefact.id,
      anexo: selected,
    };
    enqueueSnackbar("Prepare file, please wait", { variant: "info" });
    const response = await updatePdfAsync(pdfData);
    if (response && response === true) {
      setselected(false);
      setFilePdfname(selected.name);
      setpdfFile(!pdfFile);
      const response = await GetArtifactByIdAsync(
        typeof artefact?.id === "number" ? artefact._id : artefact.id
      );
      if (response !== null) {
        setartifactData(response);
        if (response?.anexo) {
          setFilePdfname(response.anexo.name);
        }

        let dataTable = GetDataTable(response.description);
        setTableData(dataTable);
      }
    }
  };

  const MitreGenerate = (array) => {
    let concat = "";
    array.forEach((element, index) => {
      if (index === array.length - 1) {
        concat += element.name;
      } else if (index === array.length - 2) {
        concat += element.name + " & ";
      } else {
        concat += element.name + ", ";
      }
    });
    return concat;
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(artifactData.md5);
    enqueueSnackbar("Copied to Clipboard", { variant: "success" });
  };
  const Reload = () => {
    props.Reload();
  };

  const GetDataTable = (str) => {
    const MALICIOUS = "MALICIOUS";
    const SUSPICIOUS = "SUSPICIOUS";
    const INFO = "INFO";
    const Desc = "Behavior Activities";
    let description;
    let filterDataMalicious;
    let filterDataSuspicios;
    let filterDataInfo;
    let existMalicious = str.includes(MALICIOUS);
    let existSuspicious = str.includes(SUSPICIOUS);
    let existInfo = str.includes(INFO);

    const index0 = str.indexOf(Desc);
    if (index0 !== -1) {
      let desc = str.split(Desc);
      description = desc[0];
    } else {
      description = str;
    }
    /**111**/
    if (
      existMalicious === true &&
      existSuspicious === true &&
      existInfo === true
    ) {
      const index = str.indexOf(MALICIOUS);
      const index2 = str.indexOf(SUSPICIOUS);

      if (index !== -1) {
        const endIndex = index2 + SUSPICIOUS.length;
        let strMalicious = str.substring(index, endIndex);
        let splitoracion = strMalicious.split("\n");
        let cleanSplit = splitoracion.map((element) => {
          return element.replace("\r", "");
        });
        filterDataMalicious = cleanSplit.filter(
          (element) =>
            element !== " " &&
            element !== " \r" &&
            element !== MALICIOUS + " " &&
            element !== MALICIOUS + " \r" &&
            element !== SUSPICIOUS
        );
      }

      const index3 = str.indexOf(SUSPICIOUS);
      const index4 = str.indexOf(INFO);
      if (index3 !== -1) {
        const endIndex = index4 + INFO.length;
        let oracion = str.substring(index3, endIndex);
        let splitoracion = oracion.split("\n");
        let cleanSplit = splitoracion.map((element) => {
          return element.replace("\r", "");
        });
        filterDataSuspicios = cleanSplit.filter(
          (element) =>
            element !== " " &&
            element !== " \r" &&
            element !== SUSPICIOUS + " " &&
            element !== SUSPICIOUS + " \r" &&
            element !== INFO
        );
      }

      const index5 = str.indexOf(INFO);
      const index6 = str.length;
      if (index5 !== -1) {
        const endIndex = index6;
        let oracion = str.substring(index5, endIndex);
        let splitoracion = oracion.split("\n");
        let cleanSplit = splitoracion.map((element) => {
          return element.replace("\r", "");
        });
        filterDataInfo = cleanSplit.filter(
          (element) =>
            element !== " " &&
            element !== "" &&
            element !== " \r" &&
            element !== INFO + " " &&
            element !== INFO + " \r"
        );
      }
    } else if (
      /**110**/
      existMalicious === true &&
      existSuspicious === true &&
      existInfo === false
    ) {
      const index = str.indexOf(MALICIOUS);
      const index2 = str.indexOf(SUSPICIOUS);

      if (index !== -1) {
        const endIndex = index2 + SUSPICIOUS.length;
        let strMalicious = str.substring(index, endIndex);
        let splitoracion = strMalicious.split("\n");
        let cleanSplit = splitoracion.map((element) => {
          return element.replace("\r", "");
        });
        filterDataMalicious = cleanSplit.filter(
          (element) =>
            element !== " " &&
            element !== " \r" &&
            element !== MALICIOUS + " " &&
            element !== MALICIOUS + " \r" &&
            element !== SUSPICIOUS
        );
      }

      const index3 = str.indexOf(SUSPICIOUS);
      const index4 = str.indexOf(INFO);
      if (index3 !== -1) {
        const endIndex = index4 + INFO.length;
        let oracion = str.substring(index3, endIndex);
        let splitoracion = oracion.split("\n");
        let cleanSplit = splitoracion.map((element) => {
          return element.replace("\r", "");
        });
        filterDataSuspicios = cleanSplit.filter(
          (element) =>
            element !== " " &&
            element !== " \r" &&
            element !== SUSPICIOUS + " " &&
            element !== SUSPICIOUS + " \r" &&
            element !== INFO
        );
      }
    } else if (
      /**101**/
      existMalicious === true &&
      existSuspicious === false &&
      existInfo === true
    ) {
      const index = str.indexOf(MALICIOUS);
      const index2 = str.indexOf(SUSPICIOUS);

      if (index !== -1) {
        const endIndex = index2 + SUSPICIOUS.length;
        let strMalicious = str.substring(index, endIndex);
        let splitoracion = strMalicious.split("\n");
        let cleanSplit = splitoracion.map((element) => {
          return element.replace("\r", "");
        });
        filterDataMalicious = cleanSplit.filter(
          (element) =>
            element !== " " &&
            element !== " \r" &&
            element !== MALICIOUS + " " &&
            element !== MALICIOUS + " \r" &&
            element !== SUSPICIOUS
        );
      }

      const index5 = str.indexOf(INFO);
      const index6 = str.length;
      if (index5 !== -1) {
        const endIndex = index6;
        let oracion = str.substring(index5, endIndex);
        let splitoracion = oracion.split("\n");
        let cleanSplit = splitoracion.map((element) => {
          return element.replace("\r", "");
        });
        filterDataInfo = cleanSplit.filter(
          (element) =>
            element !== " " &&
            element !== "" &&
            element !== " \r" &&
            element !== INFO + " " &&
            element !== INFO + " \r"
        );
      }
    } else if (
      /**100**/
      existMalicious === true &&
      existSuspicious === false &&
      existInfo === false
    ) {
      const index5 = str.indexOf(MALICIOUS);
      const index6 = str.length;
      if (index5 !== -1) {
        const endIndex = index6;
        let oracion = str.substring(index5, endIndex);
        let splitoracion = oracion.split("\n");
        let cleanSplit = splitoracion.map((element) => {
          return element.replace("\r", "");
        });
        filterDataInfo = cleanSplit.filter(
          (element) =>
            element !== " " &&
            element !== "" &&
            element !== " \r" &&
            element !== MALICIOUS + " " &&
            element !== MALICIOUS + " \r"
        );
      }
    } else if (
      /**011*/
      existMalicious === false &&
      existSuspicious === true &&
      existInfo === true
    ) {
      const index3 = str.indexOf(SUSPICIOUS);
      const index4 = str.indexOf(INFO);
      if (index3 !== -1) {
        const endIndex = index4 + INFO.length;
        let oracion = str.substring(index3, endIndex);
        let splitoracion = oracion.split("\n");
        let cleanSplit = splitoracion.map((element) => {
          return element.replace("\r", "");
        });
        filterDataSuspicios = cleanSplit.filter(
          (element) =>
            element !== " " &&
            element !== " \r" &&
            element !== SUSPICIOUS + " " &&
            element !== SUSPICIOUS + " \r" &&
            element !== INFO
        );
      }

      const index5 = str.indexOf(INFO);
      const index6 = str.length;
      if (index5 !== -1) {
        const endIndex = index6;
        let oracion = str.substring(index5, endIndex);
        let splitoracion = oracion.split("\n");
        let cleanSplit = splitoracion.map((element) => {
          return element.replace("\r", "");
        });
        filterDataInfo = cleanSplit.filter(
          (element) =>
            element !== " " &&
            element !== "" &&
            element !== " \r" &&
            element !== INFO + " " &&
            element !== INFO + " \r"
        );
      }
    } else if (
      /**010**/
      existMalicious === false &&
      existSuspicious === true &&
      existInfo === false
    ) {
      const index5 = str.indexOf(SUSPICIOUS);
      const index6 = str.length;
      if (index5 !== -1) {
        const endIndex = index6;
        let oracion = str.substring(index5, endIndex);
        let splitoracion = oracion.split("\n");
        let cleanSplit = splitoracion.map((element) => {
          return element.replace("\r", "");
        });
        filterDataInfo = cleanSplit.filter(
          (element) =>
            element !== " " &&
            element !== "" &&
            element !== " \r" &&
            element !== SUSPICIOUS + " " &&
            element !== SUSPICIOUS + " \r"
        );
      }
    } else if (
      /**001**/
      existMalicious === false &&
      existSuspicious === false &&
      existInfo === true
    ) {
      const index5 = str.indexOf(INFO);
      const index6 = str.length;
      if (index5 !== -1) {
        const endIndex = index6;
        let oracion = str.substring(index5, endIndex);
        let splitoracion = oracion.split("\n");
        let cleanSplit = splitoracion.map((element) => {
          return element.replace("\r", "");
        });
        filterDataInfo = cleanSplit.filter(
          (element) =>
            element !== " " &&
            element !== "" &&
            element !== " \r" &&
            element !== INFO + " " &&
            element !== INFO + " \r"
        );
      }
    }

    return {
      description: description,
      malicious: filterDataMalicious,
      suspicious: filterDataSuspicios,
      info: filterDataInfo,
    };
  };

  const body = (
    <Box
      className="Section"
      style={{
        backgroundcolor: "#66638f",
        borderBottom: "1px solid #1e1c3a",
        maxHeight: "700px",
        overflowY: "auto",
        overflowX: "hidden",
        minWidth: "70%",
        width: "auto",
      }}
    >
      {artifactData ? (
        <Grid container>
          <Grid
            item
            size={1}
            style={{
              backgroundColor: "rgb(13, 11, 31)",
              textAlign: "center",
              borderRadius: "14px 0 0 0",
              padding: "20px",
            }}
          >
            {artifactData.anexo?.name ? (
              <PrimaryButton
                style={{
                  display: DataUser.user.result.rol !== "admin" ? "none" : "",
                }}
                className="ArtifactButton"
                variant="contained"
                color="secondary"
                onClick={DownloadPDFFile.bind()}
              >
                <PictureAsPdf color="inherit" />
                <Typography className="labelcontent">PDF</Typography>
              </PrimaryButton>
            ) : (
              <PrimaryButton
                style={{
                  display: DataUser.user.result.rol !== "admin" ? "none" : "",
                }}
                className="ArtifactButton"
                variant="contained"
                color="secondary"
                disabled
              >
                <PictureAsPdf color="inherit" />
                <Typography className="labelcontent">PDF</Typography>
              </PrimaryButton>
            )}

            <Box>
              <Box style={{ display: Information ? "block" : "none" }}>
                <DowloadModalArtifact
                  artefact={artifactData}
                  DataUser={DataUser}
                />
                <Deletemodal
                  Reload={() => {
                    Reload();
                    setOpen(false);
                  }}
                  id={artifactData._id}
                  DataUser={DataUser}
                />
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            size={4}
            style={{
              backgroundColor: "rgb(13, 11, 31)",
              textAlign: "center",
              padding: "20px",
            }}
          >
            {artifactData.tagTest === "tested" ? (
              <Box className="TagTest Good">Tested</Box>
            ) : null}
            {artifactData.tagTest === "PartiallyTested" ? (
              <Box className="TagTest Midd">Partially Tested</Box>
            ) : null}
            {artifactData.tagTest === "untested" ? (
              <Box className="TagTest Fail">Untested</Box>
            ) : null}
            <Box
              style={{
                padding: "20px",
                marginTop: "20px",
              }}
            >
              <svg
                height="100"
                viewBox="0 0 60 60"
                width="100"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="Page-1" fill="none" fillRule="evenodd">
                  <g
                    id="063---virus-alert"
                    fill={LevelColor(artifactData.fk_threatType.name)}
                    fillRule="nonzero"
                  >
                    <path
                      id="Shape"
                      d="m55 0h-50c-2.76005315.00330612-4.99669388 2.23994685-5 5v40c.00330612 2.7600532 2.23994685 4.9966939 5 5h15.24l-1.909 1.591c-1.5051472 1.2648646-1.872953 3.4336069-.869 5.124l1.681 2.8c.1806127.3132279.516242.5045637.8777878.5004101.3615459-.0041537.6926908-.2031497.8660598-.5204443.1733689-.3172946.1619565-.7034632-.0298476-1.0099658l-1.681-2.8c-.5013245-.8428848-.3175253-1.9249281.434-2.555l2.79-2.33c1.6421696 2.6142884 4.5127318 4.2010472 7.6 4.2010472s5.9578304-1.5867588 7.6-4.2010472l2.793 2.328c.7513881.6307395.9343659 1.7133585.432 2.556l-1.68 2.8c-.1918041.3065026-.2032165.6926712-.0298476 1.0099658.173369.3172946.5045139.5162906.8660598.5204443.3615458.0041536.6971751-.1871822.8777878-.5004101l1.68-2.8c1.0049939-1.6901509.6380089-3.8594682-.867-5.125l-1.912-1.589h15.24c2.7600532-.0033061 4.9966939-2.2399468 5-5v-40c-.0033061-2.76005315-2.2399468-4.99669388-5-5zm-50 2h50c1.6568542 0 3 1.34314575 3 3v3h-56v-3c0-1.65685425 1.34314575-3 3-3zm26 50.92v-12.92c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v12.92c-3.4409267-.4966526-5.9959255-3.4434178-6-6.92v-8c-.000854-1.9949939.8545402-3.8944133 2.349-5.216 1.1371568 1.402881 2.8466206 2.2177449 4.6525 2.2177449s3.5153432-.8148639 4.6525-2.2177449c.1.087.2.168.3.264.6253444.6297458 1.1264202 1.3716908 1.477 2.187v.011c.00363.0068818.007636.0135586.012.02.367252.8647218.5566811 1.7945226.557 2.734v8c-.0040745 3.4765822-2.5590733 6.4233474-6 6.92zm3-23.92c0 2.209139-1.790861 4-4 4s-4-1.790861-4-4 1.790861-4 4-4 4 1.790861 4 4zm21 19h-16.232c.1521372-.6558489.2299605-1.3267398.232-2v-4h2.914c.4678013.0002105.9207286.1643966 1.28.464l2.166 1.8c.2747372.22865.6505882.2933607.9859735.1697563.3353853-.1236045.579352-.4167456.64-.769.0606481-.3522545-.0712363-.7101063-.3459735-.9387563l-2.165-1.8c-.7194248-.5981105-1.6254209-.9256984-2.561-.926h-2.914v-2c.0006094-.8827331-.1284344-1.7607696-.383-2.606l3.957-1.7c1.470531-.6294331 2.4246807-2.0744233 2.426-3.674v-2.02c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v2.02c.0007705.8014816-.4770063 1.5260179-1.214 1.841l-3.965 1.7c-.3998664-.7077822-.8921923-1.3591724-1.464-1.937-.235-.229-.469-.435-.706-.625.3468746-.952884.4372258-1.9801978.262-2.979l.421-.251c2.2318483-1.3485598 3.0578172-4.1825027 1.9-6.519l-.34-.69c-.2530108-.4776691-.8398074-.6678232-1.3248914-.429337-.4850841.2384861-.6928531.8192795-.4691086 1.311337l.343.7c.7146317 1.3994762.2159188 3.1134185-1.138 3.911l-.065.039c-1.0557419-1.9067823-3.0634566-3.0900704-5.243-3.0900704s-4.1872581 1.1832881-5.243 3.0900704l-.062-.037c-1.3578366-.7994013-1.8568812-2.5188685-1.138-3.921l.34-.691c.2237445-.4920575.0159755-1.0728509-.4691086-1.311337-.485084-.2384862-1.0718806-.0483321-1.3248914.429337l-.336.682c-1.1619993 2.3391828-.3357077 5.1785817 1.9 6.529l.419.25c-.176236 1.0041721-.0837769 2.0370916.268 2.994-.8778443.7050155-1.6150302 1.5690802-2.173 2.547l-3.969-1.7c-.7357049-.316797-1.2114287-1.0419906-1.209-1.843v-2.02c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v2.02c-.0010816 1.6017569.9534649 3.0497089 2.426 3.68l3.974 1.7c-.2600685.842372-.3948437 1.7184108-.4 2.6v2h-2.914c-.9357032.0005825-1.8417132.3285292-2.561.927l-2.165 1.8c-.424707.3534622-.4824622.984293-.129 1.409s.984293.4824622 1.409.129l2.166-1.8c.359133-.2999638.8120742-.4645089 1.28-.465h2.914v4c.0020395.6732602.0798628 1.3441511.232 2h-16.232c-1.65685425 0-3-1.3431458-3-3v-35h56v35c0 1.6568542-1.3431458 3-3 3z"
                    />
                    <circle id="Oval" cx="5" cy="5" r="1" />
                    <circle id="Oval" cx="9" cy="5" r="1" />
                    <circle id="Oval" cx="13" cy="5" r="1" />
                    <path
                      id="Shape"
                      d="m34 6h21c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1h-21c-.5522847 0-1 .44771525-1 1s.4477153 1 1 1z"
                    />
                  </g>
                </g>
              </svg>
            </Box>
            <Typography
              align="center"
              variant="h6"
              style={{ color: LevelColor(artifactData.fk_threatType.name) }}
            >
              {"Challenge Level : "}
              {artifactData.fk_threatType.name === "Midd"
                ? "Mid"
                : artifactData.fk_threatType.name}
            </Typography>
            <Typography
              align="center"
              variant="h6"
              style={{ color: "rgb(102, 99, 143)" }}
            >
              {artifactData.name}
            </Typography>
          </Grid>
          <Grid
            item
            size={7}
            style={{
              backgroundColor: "rgb(13, 11, 31)",
              borderRadius: "0 14px 0 0",
            }}
          >
            <Table size="small" style={{ marginTop: "32px" }}>
              <TableBody>
                <TableRow>
                  <TableCell align="right" style={styleCellName}>
                    <Typography>File Name:</Typography>
                  </TableCell>
                  <TableCell align="left" style={styleCellDescript}>
                    <Typography>{artifactData.name}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right" style={styleCellName}>
                    <Typography>Size:</Typography>
                  </TableCell>
                  <TableCell align="left" style={styleCellDescript}>
                    <Typography>{artifactData.file.size} Kb</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right" style={styleCellName}>
                    <Typography>Type:</Typography>
                  </TableCell>
                  <TableCell align="left" style={styleCellDescript}>
                    <Typography>
                      {getType(
                        artifactData.name.split(".")[
                          artifactData.name.split(".").length - 1
                        ]
                      )}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right" style={styleCellName}>
                    <Typography>Platform:</Typography>
                  </TableCell>
                  <TableCell align="left" style={styleCellDescript}>
                    <Typography>
                      {artifactData.platform === "GNULinux"
                        ? "GNU/Linux"
                        : artifactData.platform}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right" style={styleCellName}>
                    <Typography>Created:</Typography>
                  </TableCell>
                  <TableCell align="left" style={styleCellDescript}>
                    <Typography>{GetDate(artifactData.createdAt)}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right" style={styleCellName}>
                    <Typography>MD5:</Typography>
                  </TableCell>
                  <TableCell align="left" style={styleCellDescript}>
                    <Typography style={{ display: "inline-flex" }}>
                      {artifactData.md5}
                    </Typography>
                    <SecondaryButton
                      style={{ display: "inline-flex" }}
                      sx={{ width: "50px", height: "25px" }}
                      onClick={copyToClipboard.bind()}
                    >
                      <ContentPasteIcon
                        style={{
                          color: "rgb(102, 99, 143)",
                          fontSize: "small",
                        }}
                      />
                      <Typography style={{ color: "rgb(102, 99, 143)" }}>
                        Copy
                      </Typography>
                    </SecondaryButton>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right" style={styleCellName}>
                    <Typography>MITRE Attack:</Typography>
                  </TableCell>
                  <TableCell align="left" style={styleCellDescript}>
                    <Typography style={styleCellLongText}>
                      {MitreGenerate(artifactData.fk_phaseAttacks)}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right" style={styleCellName}>
                    <Typography>Callback:</Typography>
                  </TableCell>
                  <TableCell align="left" style={styleCellDescript}>
                    <Typography>
                      {artifactData.callback ? "True" : "false"}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right" style={styleCellName}>
                    <Typography>Force Network CyberSecurity:</Typography>
                  </TableCell>
                  <TableCell align="left" style={styleCellDescript}>
                    <Typography>
                      {artifactData.evasion ? "True" : "false"}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right" style={styleCellName}>
                    <Typography>VT / MITRE Link:</Typography>
                  </TableCell>
                  <TableCell align="left" style={styleCellDescript}>
                    <Typography style={styleCellLongText}>
                      {artifactData?.urlMitre ? (
                        <a
                          target="_blank"
                          href={artifactData.urlMitre}
                          rel="noreferrer"
                        >
                          {artifactData.urlMitre}
                        </a>
                      ) : (
                        "without URL"
                      )}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow
                  style={{ visibility: Information ? "visible" : "hidden" }}
                >
                  <TableCell align="right" style={styleCellName}>
                    <Typography>PDF :</Typography>
                  </TableCell>
                  <TableCell align="left" style={styleCellDescript}>
                    <Typography>
                      {FilePdfname}
                      <Tooltip title="Change PDF">
                        <IconButton
                          disabled={DataUser.user.result.rol !== "admin"}
                          onClick={() => {
                            setpdfFile(!pdfFile);
                          }}
                          style={{
                            display:
                              DataUser.user.result.rol !== "admin"
                                ? "none"
                                : "",
                            backgroundColor: "#c59d48",
                            marginLeft: "15px",
                          }}
                        >
                          <Edit style={{ color: "#fff" }} />
                        </IconButton>
                      </Tooltip>
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right" style={styleCellName}></TableCell>
                  <TableCell align="left" style={styleCellDescript}>
                    {pdfFile ? (
                      <Box style={{ width: "75%" }}>
                        <FileUpload NameID="mypdf" HandleFile={handlePdfFile} />

                        {selected ? (
                          <>
                            <Tooltip title="Cancel">
                              <Button size="small" onClick={canclePdfFile}>
                                <Cancel />
                              </Button>
                            </Tooltip>
                            <Tooltip title="Update">
                              <Button onClick={UpdateFile}>
                                <CloudUpload />
                              </Button>
                            </Tooltip>
                          </>
                        ) : (
                          ""
                        )}
                      </Box>
                    ) : (
                      ""
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>

          <Grid
            item
            size={12}
            style={{
              backgroundColor: "rgb(13, 11, 31)",
              padding: "0px 20px 0px 20px ",
            }}
          >
            <Typography>Description:</Typography>
            <Typography
              style={{
                maxWidth: "100%",
                textAlign: "justify",
                color: "rgb(102, 99, 143)",
                whiteSpace: "pre-wrap",
                height: "auto",
              }}
            >
              {tableData?.description}
            </Typography>
          </Grid>
          <Grid
            item
            size={12}
            style={{
              backgroundColor: "rgb(13, 11, 31)",
              borderRadius: "0 0 14px 14px ",
              padding: "20px",
            }}
          >
            <Typography>Behavior Activities:</Typography>
            <Typography
              style={{
                maxWidth: "100%",
                wordBreak: "break-all",
                textAlign: "justify",
                color: "rgb(102, 99, 143)",
                whiteSpace: "pre-wrap",
                marginTop: "15px",
              }}
            >
              <Grid container spacing={0}>
                <Grid item size={4}>
                  <Box className="behaivorTitle One">MALICIOUS</Box>
                  <List>
                    {tableData.length !== 0 && tableData?.malicious ? (
                      tableData.malicious.map((ele) => {
                        return (
                          <ListItem>
                            <ListItemText primary={"- " + ele} />
                          </ListItem>
                        );
                      })
                    ) : (
                      <ListItem>
                        <ListItemText primary="No Malicious Behaviour activities" />
                      </ListItem>
                    )}
                  </List>
                </Grid>
                <Grid item size={4}>
                  <Box className="behaivorTitle Two">SUSPICIOUS</Box>
                  <List>
                    {tableData.length !== 0 && tableData?.suspicious ? (
                      tableData.suspicious.map((ele) => {
                        return (
                          <ListItem>
                            <ListItemText primary={"- " + ele} />
                          </ListItem>
                        );
                      })
                    ) : (
                      <ListItem>
                        <ListItemText primary="No Suspicious Behaviour activities" />
                      </ListItem>
                    )}
                  </List>
                </Grid>
                <Grid item size={4}>
                  <Box className="behaivorTitle Three">INFO</Box>
                  <List>
                    {tableData.length !== 0 && tableData?.info ? (
                      tableData.info.map((ele) => {
                        return (
                          <ListItem>
                            <ListItemText primary={"- " + ele} />
                          </ListItem>
                        );
                      })
                    ) : (
                      <ListItem>
                        <ListItemText primary="No Info Behaviour activities" />
                      </ListItem>
                    )}
                  </List>
                </Grid>
              </Grid>
            </Typography>
          </Grid>
        </Grid>
      ) : null}
    </Box>
  );

  return (
    <Box
      style={{
        alignContent: "center",
        height: "100%",
        textAlign: "center",
        width: "100%",
        cursor: "pointer",
      }}
    >
      {LabelIcon ? (
        <Typography
          onClick={handleOpen}
          style={{
            fontFamily: "Roboto , Helvetica,Arial,sans-serif",
            fontWeight: "400",
            fontSize: "0.875rem",
            width: "100%",
            minWidth: "100px",
            maxWidth: "15vw",
            overflow: "hidden",
            textAlign: "justify",
            display: "block",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {artefact.row?.name ? artefact.row.name : artefact.name}
        </Typography>
      ) : (
        <Tooltip title="File Details">
          <IconButton className="iconButtonSize" onClick={handleOpen}>
            <img src={Eye} alt="" />
          </IconButton>
        </Tooltip>
      )}
      <Modal open={open} onClose={handleClose}>
        {body}
      </Modal>
    </Box>
  );
}
